import { combineReducers } from "redux";
import { LOGOUT } from "../actions/types";
import auth from './auth';
import common from "./common";
import dashboard from "./dashboard";
import report from "./report";
import event from "./event";
import student from "./student";
import ticket from "./ticket";

const appReducer = combineReducers({
   auth,
   common,
   dashboard,
   report,
   event,
   student,
   ticket
});

const rootReducer = (state, action) => {
   if (action.type === LOGOUT) state = undefined;
   return appReducer(state, action);
}

export default rootReducer;